$(document).ready(function(){
  console.log('ATC Popup Scripts Loaded');

  $('.atc-close').on('click', function(){
    $('.atc-popup').addClass('hidden');
  });

  $('body').on('click', '#add-to-cart', function(){
    $('.atc-popup').addClass('hidden');
    $('.atc-disable').addClass('disabled');
    $('.confirm-check').prop('checked', false);
  });
  
  $('.popup-trigger').on('click', function(e){
    console.log('Popup Click Triggered');
    e.preventDefault();
    $('.atc-popup').removeClass('hidden');
  });

  $('.confirm-check').on('click', function() {
    if ($(this).is(':checked')) {
        console.log('checked');
        $('.atc-disable').removeClass('disabled');
    } else {
        $('.atc-disable').addClass('disabled');
        console.log('NOT checked');
    }
  });

});